// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"03346f77","455":"774f4ca4","977":"240addac"}[chunkId] + ".chunk.js";
};